import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permission-flow-dialog',
  templateUrl: './permission-flow-dialog.component.html',
  styleUrls: ['./permission-flow-dialog.component.scss']
})
export class PermissionFlowDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
